module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"ไม่มีสิทธิ์ใช้งาน","error.forbidden":"คุณไม่มีสิทธิ์ใช้งานหน้าจอ หรือ การทำงานนี้","to.home":"กลับหน้าแรก","to.login":"Login"}}')
  delete Component.options._Ctor
}
